import { AuthenticationType } from "./connect-gx-server";
import { ComboBoxModel } from "@genexus/chameleon-controls-library";

export const mapAuthenticationTypeToComboBoxModel = (
  authenticationTypes: AuthenticationType[]
): ComboBoxModel => {
  return authenticationTypes.map(authenticationType => {
    return {
      value: authenticationType.id,
      caption: authenticationType.name
    };
  });
};

export const mapServerUrlsToComboBoxModel = (
  serverUrls: string[]
): ComboBoxModel => {
  return serverUrls.map(serverUrl => {
    return {
      value: serverUrl,
      caption: serverUrl
    };
  });
};
